import { createElement, forwardRef, type LabelHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) =>
  createElement('label', {
    ref,
    className: cn(
      'text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className
    ),
    ...props,
  })
);

Label.displayName = 'Label';
